// src/utils/ymapsLoader.js
let ymapsPromise = null;

export function loadYmaps(apiKey, lang = 'ru_RU') {
  if (ymapsPromise) return ymapsPromise;

  ymapsPromise = new Promise((resolve, reject) => {
    if (window.ymaps && window.ymaps.ready) {
      window.ymaps.ready(() => {
        resolve(window.ymaps);
      });
      return;
    }

    // Проверяем API ключ
    if (!apiKey) {
      const envKey = process.env.REACT_APP_YMAPS_KEY;
      if (!envKey) {
        reject(new Error('API ключ Яндекс.Карт не найден'));
        return;
      }
      apiKey = envKey;
    }

    const script = document.createElement('script');
    script.src = `https://api-maps.yandex.ru/2.1/?apikey=${apiKey}&lang=${lang}`;
    script.async = true;
    
    let timeoutId = setTimeout(() => {
      reject(new Error('Timeout loading Yandex Maps API'));
    }, 10000); // 10 секунд таймаут
    
    script.onload = () => {
      clearTimeout(timeoutId);
      if (window.ymaps && window.ymaps.ready) {
        window.ymaps.ready(() => {
          resolve(window.ymaps);
        });
      } else {
        reject(new Error('Yandex Maps API loaded but not ready'));
      }
    };
    
    script.onerror = (error) => {
      clearTimeout(timeoutId);
      console.error('Ошибка загрузки Яндекс.Карт:', error);
      console.error('Проверьте:');
      console.error('1. API ключ в переменной REACT_APP_YMAPS_KEY');
      console.error('2. Доступность api-maps.yandex.ru');
      console.error('3. Настройки домена в консоли Яндекс.Карт');
      reject(new Error('Не удалось загрузить API Яндекс.Карт. Проверьте API ключ и подключение к интернету.'));
    };
    
    document.head.appendChild(script);
  });

  return ymapsPromise;
}